/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { useFormContext, useWatch } from 'react-hook-form';
import { notificationService } from '../../../../services/notificationService';
import { EpSelectItem } from '../../../EpSelectItem';
import { InputsStep3IncidentNotification } from '../../Forms/IncidentNotification/FormIncidentNotificationDTO';

// type NotificationTypeProps = {
//   itens: {
//     id: number;
//     name: string;
//     description: string;
//   }[]
// }

export default function NotificationTypeInput({
  translations,
}: {
  translations: unknown;
}) {
  const { getNotificationTypes } = notificationService;
  const { data: typeOptions, isLoading }: { data: any; isLoading: boolean } =
    getNotificationTypes();

  const { register, unregister, setValue } = useFormContext();
  register('notificationTypeId.inputValue', {
    required: true,
  });
  const notificationType = useWatch({ name: 'notificationTypeId.inputValue' });

  const takeSelectedItem = (id: number, name: string) => {
    setValue('notificationTypeId.inputLabel', name);

    if (notificationType === undefined) {
      setValue('notificationTypeId.inputValue', id);
      return;
    }

    InputsStep3IncidentNotification.forEach((input) => {
      if ('notificationTypeId.inputValue' === input) return;
      unregister(input);
    });
    setValue('notificationTypeId.inputValue', undefined);
  };
  typeOptions?.itens.sort((a: any, b: any) => a.id - b.id);

  if (isLoading) return <></>;
  return (
    <>
      {typeOptions?.itens.map((item: any, index: number) => {
        const selectedItemValidation =
          notificationType === undefined || item.id === notificationType;
        return (
          selectedItemValidation && (
            <EpSelectItem
              id={item.id}
              key={index}
              title={item.name}
              description={item.description}
              selectedItem={notificationType}
              setSelectedItem={() => takeSelectedItem(item.id, item.name)}
              translations={translations}
            ></EpSelectItem>
          )
        );
      })}
    </>
  );
}
